import { rfqActionTypes } from '@Actions/purchase/rfq/rfqActions';

const RfqReducers = (state = { }, action) => {
  switch (action.type) {
  case rfqActionTypes.GET_RFQ.LOADING: {
    const { getRfqLoading } = action;
    return {
      ...state,
      getRfqLoading,
    };
  }
  case rfqActionTypes.GET_RFQ.SUCCESS: {
    const { rfqs } = action;
    return {
      ...state,
      rfqs,
    };
  }
  case rfqActionTypes.CREATE_RFQ.LOADING: {
    const { createRfqLoading } = action;
    return {
      ...state,
      createRfqLoading,
    };
  }
  case rfqActionTypes.UPDATE_RFQ.LOADING: {
    const { updateRfqLoading } = action;
    return {
      ...state,
      updateRfqLoading,
    };
  }
  case rfqActionTypes.UPDATE_RFQ_PARTICIPANT.LOADING: {
    const { updateRfqParticipantLoading } = action;
    return {
      ...state,
      updateRfqParticipantLoading,
    };
  }
  case rfqActionTypes.UPDATE_RFQ_CONFIG.LOADING: {
    const { updateRfqConfigLoading } = action;
    return {
      ...state,
      updateRfqConfigLoading,
    };
  }
  case rfqActionTypes.GET_RFQ_BY_ID.LOADING: {
    const { getRfqByIdLoading } = action;
    return {
      ...state,
      getRfqByIdLoading,
    };
  }
  case rfqActionTypes.GET_RFQ_BY_ID.SUCCESS: {
    const { selectedRfq } = action;
    return {
      ...state,
      selectedRfq,
    };
  }
  case rfqActionTypes.SEND_RFQ_NOTIFICATION.LOADING: {
    const { sendRfqNotificationLoading } = action;
    return {
      ...state,
      sendRfqNotificationLoading,
    };
  }
  case rfqActionTypes.DELETE_RFQ.LOADING: {
    const { deleteRfqLoading } = action;
    return {
      ...state,
      deleteRfqLoading,
    };
  }
  case rfqActionTypes.UPDATE_STATUS_RFQ.LOADING: {
    const { updateRfqStatusLoading } = action;
    return {
      ...state,
      updateRfqStatusLoading,
    };
  }
  case rfqActionTypes.GET_PUBLIC_RFQ.LOADING: {
    const { getPublicRfqLoading } = action;
    return {
      ...state,
      getPublicRfqLoading,
    };
  }
  case rfqActionTypes.GET_PUBLIC_RFQ.SUCCESS: {
    const { publicRfq } = action;
    return {
      ...state,
      publicRfq,
    };
  }
  case rfqActionTypes.GET_PUBLIC_RFQ.ERROR: {
    const { publicRfqError } = action;
    return {
      ...state,
      publicRfqError,
    };
  }
  case rfqActionTypes.NEGOTIATION.LOADING: {
    const { actionType, loading } = action;
    return {
      ...state,
      [`${actionType}Loading`]: loading,
    };
  }
  case rfqActionTypes.GET_ACCEPTED_OFFERS.LOADING: {
    const { getAcceptedOffersLoading } = action;
    return {
      ...state,
      getAcceptedOffersLoading,
    };
  }
  case rfqActionTypes.GET_ACCEPTED_OFFERS.SUCCESS: {
    const { acceptedOffers } = action;
    return {
      ...state,
      acceptedOffers,
    };
  }
  case rfqActionTypes.GET_RFQ_PARTICIPANT_NEGOTIATIONS.LOADING: {
    const { getRfqParticipantNegotiationsLoading } = action;
    return {
      ...state,
      getRfqParticipantNegotiationsLoading,
    };
  }
  case rfqActionTypes.GET_RFQ_PARTICIPANT_NEGOTIATIONS.SUCCESS: {
    const { participantNegotiations } = action;
    return {
      ...state,
      participantNegotiations,
    };
  }
  default: {
    return state;
  }
  }
};

export default RfqReducers;
